import React from 'react';
import './Website.css';

const TermsOfService = () => {
  return (
    <main className="site-page legal-page">
      <article className="section-inner legal-card">
        <h1>
          Unsubscriber's Terms of Service
        </h1>
        <p>
          Welcome to Unsubscriber, a Chrome extension designed to help you batch
          unsubscribe from emails and manage your inbox efficiently. By using our
          service, you agree to the following terms and conditions. If you do not
          agree, please do not use our service.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using the Unsubscriber extension, you acknowledge that
          you have read, understood, and agree to be bound by these Terms of
          Service. If you are using the service on behalf of a company or
          organization, you agree to these terms on their behalf.
        </p>

        <h2>2. Service Description</h2>
        <p>Unsubscriber provides tools to help users manage their email inboxes by:</p>
        <ul>
          <li>Batch unsubscribing from unwanted emails.</li>
          <li>Deleting cluttered or unwanted emails.</li>
          <li>
            Saving inbox space and reducing the need to purchase additional
            storage.
          </li>
        </ul>
        <p>
          We offer one paid subscription plan at <strong>$9.99/year</strong>,
          which includes unlimited scan history and 36 scans per year.
        </p>

        <h2>3. User Responsibilities</h2>
        <p>
          Users are responsible for ensuring that their use of Unsubscriber
          complies with applicable laws and regulations. You agree not to use the
          service for any unlawful or abusive purposes, including but not limited
          to:
        </p>
        <ul>
          <li>Attempting to access accounts without proper authorization.</li>
          <li>
            Using the service to harm, abuse, or harass other individuals or
            entities.
          </li>
          <li>Reverse engineering or tampering with the service.</li>
        </ul>

        <h2>4. Privacy Policy</h2>
        <p>
          Your privacy is important to us. Our Privacy Policy explains how we
          collect, use, and protect your personal data while using Unsubscriber.
          By using our service, you agree to our data practices as described in
          the Privacy Policy.
        </p>
        <p>
          We do not hold user data for privacy. We do not store your user data or
          usage data on servers or anywhere. We only store customer information if
          you purchase an upgrade, and this data is stored exclusively on Stripe.com.
        </p>

        <h2>5. Subscription Plans and Payment</h2>
        <p>
          The paid plan is a subscription-based service. Payment is due at the
          time of purchase. Subscriptions renew automatically for one year unless
          canceled before the renewal date. Refunds are only provided if the
          software is proven to be broken, and proof of the defect is required.
        </p>

        <h2>6. Termination</h2>
        <p>
          You may terminate your subscription at any time. Upon termination, all services provided under the subscription will be discontinued immediately.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          Unsubscriber is provided "as is" and "as available" without warranties
          of any kind, express or implied, including but not limited to implied
          warranties of merchantability, fitness for a particular purpose, and
          non-infringement. We do not guarantee the accuracy, reliability, or
          availability of the service at all times.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Unsubscriber and its owners,
          affiliates, and partners shall not be liable for any direct, indirect,
          incidental, consequential, or punitive damages arising from your use of
          the service, except where prohibited by law.
        </p>

        <h2>9. Changes to the Terms of Service</h2>
        <p>
          We reserve the right to modify or update these Terms of Service at any
          time. Changes will be effective immediately upon posting. It is your
          responsibility to review these terms regularly. Continued use of the
          service constitutes your acceptance of any changes.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms of Service are governed by and construed in accordance with
          the laws of the State of New York. Any disputes arising from these terms
          will be resolved in the courts of New York.
        </p>

        <h2>11. Accessibility</h2>
        <p>
          The service is not guaranteed to meet accessibility standards, and we make no commitments to ensure accessibility compliance.
        </p>

        <h2>12. Compliance and Security</h2>
        <p>
          We comply with OWASP, GDPR, and NIST cybersecurity standards. Our service is built on a zero-trust architecture, and our code is reviewed by Google for security and authorization before being allowed on Google’s extensions marketplace.
        </p>

        <footer>
          <p>&copy; {new Date().getFullYear()} Unsubscriber. All rights reserved.</p>
        </footer>
      </article>
    </main>
  );
};

export default TermsOfService;
